import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

/** Error codes the API's SqlConflictExceptionFilter answers a save that collided with other work (503 / 409). */
const SQL_CONFLICT_KEYS: Record<string, string> = {
  DEADLOCK_RETRY: 'COMMON.DEADLOCK_RETRY',
  COMPANY_NOT_FOUND: 'COMMON.COMPANY_NOT_FOUND',
};

/** Translation key for a SQL-conflict error body, or null for any other body. */
export function sqlConflictMessageKey(errorBody: unknown): string | null {
  if (!errorBody || typeof errorBody !== 'object') return null;
  const code = (errorBody as Record<string, unknown>)['code'];
  return typeof code === 'string' && Object.prototype.hasOwnProperty.call(SQL_CONFLICT_KEYS, code)
    ? SQL_CONFLICT_KEYS[code]
    : null;
}

/**
 * Returns the same error with the body's `message` replaced by the translated text for the two SQL-conflict codes,
 * so every page that shows the server message shows a clear one. Any other error is returned untouched. Never retries.
 */
export function withSqlConflictMessage(err: HttpErrorResponse, translate: TranslateService): HttpErrorResponse {
  const key = sqlConflictMessageKey(err?.error);
  if (!key) return err;
  return new HttpErrorResponse({
    error: { ...(err.error as object), message: translate.instant(key) },
    headers: err.headers,
    status: err.status,
    statusText: err.statusText,
    url: err.url ?? undefined,
  });
}
